export default __webpack_public_path__ + "static/media/hydraulica-comercial-logo.4d31270b.png";